import React from 'react';
import { formatCurrency } from './putils';
import "../css/styles.css"
const Info = ({ product, showFullDescription = true, typeName }) => {
  if (!product) return null;
const cleanDescription = (html) => {
    if (!html) return "";
    // Thay thế tất cả &nbsp; thành khoảng trắng thường
    return html.replace(/&nbsp;/g, ' ');
  };
  return (
    <div className="product-detail-box">
      <h1 className="product-title">{product.name || product.title}</h1>
      <p className="product-price">{product.price && formatCurrency(product.price)}</p>
      
      <div className="product-description-wrapper">
        <h3 className="section-title">{typeName && typeName}</h3>
        {showFullDescription ? (
          <div 
            className="rich-text-content"
            // In dữ liệu HTML từ Database (Firestore)
            dangerouslySetInnerHTML={{ __html: cleanDescription(product.description || product.content) }} 
          />
        ) : (
          <p>{product.shortDescription}</p>
        )}
      </div>
    </div>
  );
};

export default Info;